var mapColors = function mapColors(colours) {
  return colours.map(function (c) {
    return c.color;
  });
};
export default mapColors;